import { IExpenseRepository } from "domain/contracts/expense.contracts";
import { Expense } from "domain/entities/expense";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { ExpenseInputFilter } from "domain/models/expense-input-filter";
import { formatDate } from "presentation/utils/formatEndDate";

class ExpenseRepository implements IExpenseRepository {
  async create(input: Expense): Promise<Message<boolean>> {
    let date = formatDate(input.date);
    if (date)
      input = {
        ...input,
        date: date,
      };

    const response = await httpClient.post(`/expense`, { data: input });
    return response.data;
  }

  async update(input: Expense): Promise<Message<boolean>> {
    let date = formatDate(input.date);
    if (date)
      input = {
        ...input,
        date: date,
      };

    const response = await httpClient.put(`/expense/${input.id}`, {
      data: input,
    });
    return response.data;
  }

  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/expense/${id}`);
    return response.data;
  }

  async getById(id: string): Promise<Message<Expense>> {
    const response = await httpClient.get(`/expense/${id}`);
    return response.data;
  }

  async getByFilter(filter: ExpenseInputFilter): Promise<Message<Expense[]>> {
    const response = await httpClient.get(`/expense`, { params: filter });
    return response.data;
  }
}

export default new ExpenseRepository();
